import { useState } from 'react';

export default function useInputState(initialState) {
    const [value, setValue] = useState(initialState);
    return [value, (event) => setValue(event.target.value)];
}
